module.exports = __webpack_public_path__ + "static/img/w3-2.d22bcb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd102/w3-2.png
// module id = pl7s
// module chunks = 1